import { SETTING_TABS } from "../../pages/SettingsPage/SettingsPage";
import { LoginCardKey, LoginPageCard } from "./auth.types";

export enum UserRoles {
  Obveznik = "OBVEZNIK",
  ObveznikMarkice = "OBVEZNIKMARKICE",
  ObveznikDozvole = "OBVEZNIKDOZVOLE",
  ObveznikOvlascenaLica = "OBVEZNIKOVLASCENALICA",
  ObveznikKorisnici = "OBVEZNIKKORISNICI",
  ObveznikKonfiguracija = "OBVEZNIKKONFIGURACIJA",
  ObveznikObjekti = "OBVEZNIKOBJEKTI",
  ObveznikSkeniranje = "OBVEZNIKSKENIRANJE",
  ObveznikPuObrasci = "OBVEZNIKPUOBRASCI",
  ObveznikTT = "OBVEZNIKTT",
  ObveznikPeriodicniIzvestaj = "OBVEZNIKPERIODICNIIZVESTAJ",
  ObveznikProdukcioniKodovi = "OBVEZNIKPRODUKCIONIKODOVI",
  ObveznikRegistriPregled = "OBVEZNIKREGISTRIPREGLED",
  Mfin = "MFIN",
  MfinKorisnici = "MFINKORISNICI",
  MfinMarkice = "MFINMARKICE",
  MfinEvidencijaVracenih = "MFINEVIDENCIJAVRACENIH",
  MfinDozvole = "MFINDOZVOLE",
  MfinRegistriPregled = "MFINREGISTRIPREGLED",
  MfinKonfiguracija = "MFINKONFIGURACIJA",
  MfinProdukcioniKodovi = "MFINPRODUKCIONIKODOVI",
  MfinPuObrasci = "MFINPUOBRASCI",
  MfinPeriodicniIzvestaj = "MFINPERIODICNIIZVESTAJ",
  MfinTT = "MFINTT",
  MfinTTIzvestajPromet = "MFINTTIZVESTAJPROMET",
}

// Todo: make paths an enum
export const USER_REDIRECT_MAP = {
  // [UserRoles.Obveznik]: "", where to redirect? do we have other roles or we get only obveznik for zakonski zastupnik
  [UserRoles.Obveznik]: "/obveznik/podesavanja",
  [UserRoles.ObveznikMarkice]: "/obveznik/akcizneMarkice/noviZahtev",
  [UserRoles.ObveznikDozvole]: "/obveznik/akcizneDozvole/listaDozvola",
  [UserRoles.ObveznikOvlascenaLica]: "/obveznik/akcizneMarkice/ovlascenaLica",
  [UserRoles.ObveznikKorisnici]: `/obveznik/podesavanja?active=${SETTING_TABS.COMPANY_USERS}`,
  [UserRoles.ObveznikKonfiguracija]: `/obveznik/podesavanja?active=${SETTING_TABS.API_SETTINGS}`,
  [UserRoles.ObveznikObjekti]: `/obveznik/podesavanja?active=${SETTING_TABS.COMPANY_OBJECTS}`,
  // [UserRoles.ObveznikSkeniranje]: "", where to redirect?
  [UserRoles.ObveznikSkeniranje]: "/obveznik/podesavanja",
  [UserRoles.ObveznikPuObrasci]: "/obveznik/puObrasci",
  [UserRoles.ObveznikTT]: "/obveznik/trackAndTrace/pracenje",
  [UserRoles.ObveznikPeriodicniIzvestaj]:
    "/obveznik/akcizneMarkice/evidencijaIskoriscenihMarkica",
  [UserRoles.ObveznikProdukcioniKodovi]: "/obveznik/produkcioniKodovi",
  // [UserRoles.ObveznikRegistriPregled]: "/", where to redirect, can obveznik see registry at the end?
  [UserRoles.ObveznikRegistriPregled]: "/obveznik/podesavanja",
  // [UserRoles.Mfin]: "", where to redirect
  [UserRoles.Mfin]: "/obveznik/podesavanja",
  [UserRoles.MfinKorisnici]: `/mfin/podesavanja?active=${SETTING_TABS.COMPANY_USERS}`,
  [UserRoles.MfinKonfiguracija]: `/mfin/podesavanja?active=${SETTING_TABS.API_SETTINGS}`,
  [UserRoles.MfinMarkice]: "/mfin/listaMarkica",
  [UserRoles.MfinEvidencijaVracenih]: "/mfin/evidencijaVracenihMarkica",
  [UserRoles.MfinDozvole]: "/mfin/listaDozvola",
  [UserRoles.MfinRegistriPregled]: "/mfin/centralniRegistar/registri",
  [UserRoles.MfinProdukcioniKodovi]: "/mfin/produkcioniKodovi",
  [UserRoles.MfinPuObrasci]: "/mfin/puObrasci",
  [UserRoles.MfinPeriodicniIzvestaj]: "/mfin/periodicniIzvestaji",
  [UserRoles.MfinTT]: "/mfin/trackAndTrace/pracenje",
  [UserRoles.MfinTTIzvestajPromet]: "/mfin/trackAndTrace/izvestajiOPrometu",
};

export enum RouteSections {
  OBVEZNIK = "obveznik",
  OBVEZNIK_MARKICE = "obveznik_markice",
  OBVEZNIK_DOZVOLE = "obveznik_dozvole",
  OBVEZNIK_OVLASCENA_LICA = "obveznik_ovlascena_lica",
  OBVEZNIK_KORISNICI = "obveznik_korisnici",
  OBVEZNIK_KONFIGURACIJA = "obveznik_konfiguracija",
  OBVEZNIK_OBJEKTI = "obveznik_objekti",
  OBVEZNIK_SKENIRANJE = "obveznik_skeniranje",
  OBVEZNIK_PU_OBRASCI = "obveznik_pu_obrasci",
  OBVEZNIK_TT = "obveznik_tt",
  OBVEZNIK_PERIODICNI_IZVESTAJ = "obveznik_periodicni_izvestaj",
  OBVEZNIK_PRODUKCIONI_KODOVI = "obveznik_produkcioni_kodovi",
  OBVEZNIK_REGISTRI_PREGLED = "obveznik_registri_pregled",
  MFIN = "mfin",
  MFIN_KORISNICI = "mfin_korisnici",
  MFIN_MARKICE = "mfin_markice",
  MFIN_EVIDENCIJA_VRACENIH = "mfin_evidencija_vracenih",
  MFIN_DOZVOLE = "mfin_dozvole",
  MFIN_REGISTRI_PREGLED = "mfin_registri_pregled",
  MFIN_KONFIGURACIJA = "mfin_konfiguracija",
  MFIN_PRODUKCIONI_KODOVI = "mfin_produkcioni_kodovi",
  MFIN_PU_OBRASCI = "mfin_pu_obrasci",
  MFIN_PERIODICNI_IZVESTAJ = "mfin_periodicni_izvestaj",
  MFIN_TT = "mfin_tt",
  MFIN_TT_IZVESTAJ_PROMET = "mfin_tt_izvestaj_promet",
}

export type IRouteAccessConfig = {
  [key in RouteSections]: {
    read: UserRoles[];
    write: UserRoles[];
  };
};

export const ROUTE_ACCESS_MAP: IRouteAccessConfig = {
  [RouteSections.OBVEZNIK]: {
    read: [
      UserRoles.Obveznik,
      UserRoles.ObveznikDozvole,
      UserRoles.ObveznikKonfiguracija,
      UserRoles.ObveznikKorisnici,
      UserRoles.ObveznikMarkice,
      UserRoles.ObveznikObjekti,
      UserRoles.ObveznikOvlascenaLica,
      UserRoles.ObveznikPeriodicniIzvestaj,
      UserRoles.ObveznikProdukcioniKodovi,
      UserRoles.ObveznikPuObrasci,
      UserRoles.ObveznikRegistriPregled,
      UserRoles.ObveznikSkeniranje,
      UserRoles.ObveznikTT,
    ],
    write: [
      UserRoles.Obveznik,
      UserRoles.ObveznikDozvole,
      UserRoles.ObveznikKonfiguracija,
      UserRoles.ObveznikKorisnici,
      UserRoles.ObveznikMarkice,
      UserRoles.ObveznikObjekti,
      UserRoles.ObveznikOvlascenaLica,
      UserRoles.ObveznikPeriodicniIzvestaj,
      UserRoles.ObveznikProdukcioniKodovi,
      UserRoles.ObveznikPuObrasci,
      UserRoles.ObveznikRegistriPregled,
      UserRoles.ObveznikSkeniranje,
      UserRoles.ObveznikTT,
    ],
  },
  [RouteSections.OBVEZNIK_MARKICE]: {
    read: [
      UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
      // UserRoles.ObveznikPeriodicniIzvestaj,
    ],
    write: [
      UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
      // UserRoles.ObveznikPeriodicniIzvestaj,
    ],
  },
  [RouteSections.OBVEZNIK_DOZVOLE]: {
    read: [UserRoles.ObveznikDozvole, UserRoles.Obveznik],
    write: [UserRoles.ObveznikDozvole, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_OVLASCENA_LICA]: {
    read: [
      UserRoles.ObveznikOvlascenaLica,
      // UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
    ],
    write: [
      UserRoles.ObveznikOvlascenaLica,
      // UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
    ],
  },
  [RouteSections.OBVEZNIK_KORISNICI]: {
    read: [UserRoles.ObveznikKorisnici, UserRoles.Obveznik],
    write: [UserRoles.ObveznikKorisnici, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_KONFIGURACIJA]: {
    read: [UserRoles.ObveznikKonfiguracija, UserRoles.Obveznik],
    write: [UserRoles.ObveznikKonfiguracija, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_OBJEKTI]: {
    read: [UserRoles.ObveznikObjekti, UserRoles.Obveznik],
    write: [UserRoles.ObveznikObjekti, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_SKENIRANJE]: {
    read: [UserRoles.ObveznikSkeniranje, UserRoles.Obveznik],
    write: [UserRoles.ObveznikSkeniranje, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_PU_OBRASCI]: {
    read: [UserRoles.ObveznikPuObrasci, UserRoles.Obveznik],
    write: [UserRoles.ObveznikPuObrasci, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_TT]: {
    read: [UserRoles.ObveznikTT, UserRoles.Obveznik],
    write: [UserRoles.ObveznikTT, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_PERIODICNI_IZVESTAJ]: {
    read: [
      UserRoles.ObveznikPeriodicniIzvestaj,
      // UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
    ],
    write: [
      UserRoles.ObveznikPeriodicniIzvestaj,
      // UserRoles.ObveznikMarkice,
      UserRoles.Obveznik,
    ],
  },
  [RouteSections.OBVEZNIK_PRODUKCIONI_KODOVI]: {
    read: [UserRoles.ObveznikProdukcioniKodovi, UserRoles.Obveznik],
    write: [UserRoles.ObveznikProdukcioniKodovi, UserRoles.Obveznik],
  },
  [RouteSections.OBVEZNIK_REGISTRI_PREGLED]: {
    read: [UserRoles.ObveznikRegistriPregled, UserRoles.Obveznik],
    write: [UserRoles.ObveznikRegistriPregled, UserRoles.Obveznik],
  },
  [RouteSections.MFIN]: {
    read: [
      UserRoles.Mfin,
      UserRoles.MfinDozvole,
      UserRoles.MfinKonfiguracija,
      UserRoles.MfinKorisnici,
      UserRoles.MfinMarkice,
      UserRoles.MfinEvidencijaVracenih,
      UserRoles.MfinPeriodicniIzvestaj,
      UserRoles.MfinProdukcioniKodovi,
      UserRoles.MfinPuObrasci,
      UserRoles.MfinRegistriPregled,
      UserRoles.MfinTT,
      UserRoles.MfinTTIzvestajPromet,
    ],
    write: [
      UserRoles.Mfin,
      UserRoles.MfinDozvole,
      UserRoles.MfinKonfiguracija,
      UserRoles.MfinKorisnici,
      UserRoles.MfinMarkice,
      UserRoles.MfinEvidencijaVracenih,
      UserRoles.MfinPeriodicniIzvestaj,
      UserRoles.MfinProdukcioniKodovi,
      UserRoles.MfinPuObrasci,
      UserRoles.MfinRegistriPregled,
      UserRoles.MfinTT,
      UserRoles.MfinTTIzvestajPromet,
    ],
  },
  [RouteSections.MFIN_KORISNICI]: {
    read: [UserRoles.MfinKorisnici, UserRoles.Mfin],
    write: [UserRoles.MfinKorisnici, UserRoles.Mfin],
  },
  [RouteSections.MFIN_MARKICE]: {
    read: [UserRoles.MfinMarkice, UserRoles.Mfin],
    write: [UserRoles.MfinMarkice, UserRoles.Mfin],
  },
  [RouteSections.MFIN_EVIDENCIJA_VRACENIH]: {
    read: [UserRoles.MfinEvidencijaVracenih, UserRoles.Mfin],
    write: [UserRoles.MfinEvidencijaVracenih, UserRoles.Mfin],
  },
  [RouteSections.MFIN_DOZVOLE]: {
    read: [UserRoles.MfinDozvole, UserRoles.Mfin],
    write: [UserRoles.MfinDozvole, UserRoles.Mfin],
  },
  [RouteSections.MFIN_REGISTRI_PREGLED]: {
    read: [UserRoles.MfinRegistriPregled, UserRoles.Mfin],
    write: [UserRoles.MfinRegistriPregled, UserRoles.Mfin],
  },
  [RouteSections.MFIN_KONFIGURACIJA]: {
    read: [UserRoles.MfinKonfiguracija, UserRoles.Mfin],
    write: [UserRoles.MfinKonfiguracija, UserRoles.Mfin],
  },
  [RouteSections.MFIN_PRODUKCIONI_KODOVI]: {
    read: [UserRoles.MfinProdukcioniKodovi, UserRoles.Mfin],
    write: [UserRoles.MfinProdukcioniKodovi, UserRoles.Mfin],
  },
  [RouteSections.MFIN_PU_OBRASCI]: {
    read: [UserRoles.MfinPuObrasci, UserRoles.Mfin],
    write: [UserRoles.MfinPuObrasci, UserRoles.Mfin],
  },
  [RouteSections.MFIN_PERIODICNI_IZVESTAJ]: {
    read: [UserRoles.MfinPeriodicniIzvestaj, UserRoles.Mfin],
    write: [UserRoles.MfinPeriodicniIzvestaj, UserRoles.Mfin],
  },
  [RouteSections.MFIN_TT]: {
    read: [UserRoles.MfinTT, UserRoles.Mfin],
    write: [UserRoles.MfinTT, UserRoles.Mfin],
  },
  [RouteSections.MFIN_TT_IZVESTAJ_PROMET]: {
    read: [UserRoles.MfinTTIzvestajPromet, UserRoles.Mfin],
    write: [UserRoles.MfinTTIzvestajPromet, UserRoles.Mfin],
  },
};

export const LOGIN_PAGE_CARDS: LoginPageCard[] = [
  {
    slideNumber: 1,
    key: LoginCardKey.INFORMACIJE_O_SISTEMU,
    translationKey: "LOGIN.INFORMACIJE_O_SISTEMU",
    title: "Informacije o sistemu",
    textTranslationKey: "LOGIN.INFORMACIJE_O_SISTEMU_PARAGRAPH_1",
  },
  {
    slideNumber: 2,
    key: LoginCardKey.AKCIZNI_PROIZVODI,
    translationKey: "LOGIN.AKCIZNI_PROIZVODI",
    title: "Akcizni proizvodi",
    textTranslationKey: "LOGIN.AKCIZNI_PROIZVODI_PARAGRAPH",
  },
  {
    slideNumber: 3,
    key: LoginCardKey.PROPISI,
    translationKey: "LOGIN.PROPISI",
    title: "Propisi",
    textTranslationKey: "LOGIN.PROPISI_PARAGRAPH",
  },
];
